module.exports = __webpack_public_path__ + "static/media/arrow-right-white.496d0b77.svg";